// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3jGc0","requiredAsterisk":"Info_requiredAsterisk__1QVHf"};